export default __webpack_public_path__ + "static/media/NFT_8.044fc3cb.png";